import React from 'react';
import { string } from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Picture = ({ imagePath, imgClass, alt }) => {
  return (
    <picture>
      <source srcSet={`/content/images/${imagePath}.webp`} type="image/webp" />
      <source srcSet={`/content/images/${imagePath}.jpg`} type="image/jpeg" />
      <LazyLoadImage
        src={`/content/images/${imagePath}.jpg`}
        alt={alt}
        className={imgClass}
      />
    </picture>
  );
};

Picture.propTypes = {
  imagePath: string,
  imgClass: string,
  altText: string
};

Picture.defaultProps = {
  webpath: '',
  imgClass: '',
  altText: 'image'
};

export default Picture;
